// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__urel8","notes":"Notes_notes__eXnVy","note":"Notes_note__2NMO2","markdown":"Notes_markdown__zFKzK"};